import LoadingHomeSkeleton from 'components/shared/loading-home-skeleton'
import ProposedSimulationCard from 'components/shared/proposed-simulation-card'
import { TitleSection } from 'components/shared/title-section'
import useTranslation from 'next-translate/useTranslation'

import BoxEmptySimulations from './box-empty-sim'
import SeeAllButton from './see-all-button'

interface ProposedSimulationSectionProps {
    loading?: boolean
    simulations?: ExamSimulation[]
    setIndexTab: (tab: number) => void
}

const ProposedSimulationSection = (props: ProposedSimulationSectionProps) => {
    const { t } = useTranslation('simulation')
    return (
        <>
            <TitleSection
                loading={props.loading}
                title={t('proposedSection.title')}
                pt="0px"
                subtitle={t('proposedSection.description')}
            />
            <div>
                {props.simulations && props.simulations.length <= 0 && !props.loading ? (
                    <BoxEmptySimulations
                        title={t('emptyState.proposed.title')}
                        subtitle={t('emptyState.proposed.description')}
                    />
                ) : (
                    <div className="flex flex-col">
                        <div className="flex flex-col sm:flex-row  gap-2">
                            {props.loading ? (
                                <LoadingHomeSkeleton />
                            ) : (
                                <div className="flex flex-col lg:flex-row w-full gap-2">
                                    {props.simulations
                                        ?.map((sim, idx) => (
                                            <div className="w-full lg:w-4/12" key={sim._id}>
                                                <ProposedSimulationCard testid={`proposed-${idx}`} simulation={sim} />
                                            </div>
                                        ))
                                        .slice(0, 3)}
                                </div>
                            )}
                        </div>

                        <SeeAllButton loading={props.loading} onClick={() => props.setIndexTab(1)} />
                    </div>
                )}
            </div>
        </>
    )
}

export default ProposedSimulationSection
